import React, { useEffect, useState } from "react";
import { Container, Form, Button, Table, Spinner } from "react-bootstrap";
import api from "../components/Api";

export default function AddquestionBank() {
  const [bankName, setBankName] = useState("");
  const [description, setDescription] = useState("");

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [questionBanks, setQuestionBanks] = useState([]);

  // Load existing banks
  const loadBanks = async () => {
    try {
        //https://pustakexam.webndro.com/api/questionbank/banks
      const res = await api.get("/questionbank/banks");
      console.log('ques',res);
      if (res.data.status === "success") {
        setQuestionBanks(res.data.data || []);
      }
    } catch (err) {
      console.error("Error loading banks", err);
    }
  };

  useEffect(() => {
    loadBanks();
  }, []);

  // Validation (no alerts)
  const validateForm = () => {
    const newErrors = {};

    if (!bankName.trim()) newErrors.bankName = "Bank Name is required";
    if (!description.trim()) newErrors.description = "Description is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // Save / Update
  const handleSave = async () => {
    if (!validateForm()) return;

    setLoading(true);

    const payload = {
      bank_name: bankName,
      description: description,
    };

    try {
      let res;
      if (editingId) {
        res = await api.put(`/questionbank/bank/${editingId}`, payload);
      } else {
        res = await api.post("/questionbank/bank", payload);
      }

      if (res.data.status === "success") {
        setBankName("");
        setDescription("");
        setEditingId(null);
        setErrors({});
        loadBanks();
      } else {
        console.log("Something went wrong");
      }
    } catch (err) {
      console.error("Error saving bank:", err);
    } finally {
      setLoading(false);
    }
  };

  // Edit
  const handleEdit = (bank) => {
    setEditingId(bank.bank_id);
    setBankName(bank.bank_name);
    setDescription(bank.description);
    setErrors({});
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this bank?")) return;

    try {
      const res = await api.delete(`/questionbank/bank/${id}`);
      if (res.data.status === "success") {
        loadBanks();
      }
    } catch (err) {
      console.error("Error deleting:", err);
    }
  };

  // UI
  return (
    <Container className="py-4">
      <h3 className="mb-4 text-primary">ADD Question Bank</h3>

      <div className="p-3 border rounded mb-4 bg-light">

        {/* Bank Name */}
        <Form.Group className="mb-3">
          <Form.Label>Bank Name</Form.Label>
          <Form.Control
            type="text"
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
            placeholder="Enter bank name"
            isInvalid={!!errors.bankName}
          />
          <Form.Control.Feedback type="invalid">
            {errors.bankName}
          </Form.Control.Feedback>
        </Form.Group>

        {/* Description */}
        <Form.Group className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter description"
            isInvalid={!!errors.description}
          />
          <Form.Control.Feedback type="invalid">
            {errors.description}
          </Form.Control.Feedback>
        </Form.Group>

        <Button onClick={handleSave} disabled={loading} variant="primary">
          {loading ? <Spinner size="sm" /> : editingId ? "Update" : "Save"}
        </Button>
      </div>

      {/* Table List */}
      <h5 className="mb-3">Saved Banks</h5>

      <Table bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Bank Name</th>
            <th>Description</th>
            <th width="180px">Actions</th>
          </tr>
        </thead>

        <tbody>
          {questionBanks.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center text-muted">
                No banks found
              </td>
            </tr>
          ) : (
            questionBanks.map((item, index) => (
              <tr key={item.bank_id}>
                <td>{index + 1}</td>
                <td>{item.bank_name}</td>
                <td>{item.description}</td>
                <td>
                  <Button size="sm" variant="info" className="me-2" onClick={() => handleEdit(item)}>
                    Edit
                  </Button>
                  <Button size="sm" variant="danger" onClick={() => handleDelete(item.bank_id)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </Container>
  );
}
